export default __webpack_public_path__ + "static/media/selectedFile.cb5ff353.svg";